<form
  #userForm="ngForm"
  id="forms.userForm"
  role="form"
  name="forms.userForm"
  autocomplete="on"
  (submit)="save()"
  novalidate
>
  <div
    rvSpinner="user-settings"
    [rvShowSpinner]="loading"
    class="settings-page-container"
  >
    <div class="settings-page-body">
      <h3 class="tw-font-bold tw-text-[22.5px] tw-mb-5">Add User</h3>
      <div id="user-settings" class="tw-flex tw-flex-col tw-gap-8">
        <user-fields [user]="user" [isAddMode]="true"></user-fields>
        @if (formError) {
          <notification-alert
            id="user-form-error"
            type="danger"
            [title]="formError"
            [message]="apiError"
          >
          </notification-alert>
        }
      </div>
    </div>
    <div class="settings-page-footer">
      <common-actions [actions]="actions" [saving]="loading"> </common-actions>
    </div>
  </div>
</form>
